import { SUCCESS_SUFFIX, FAILURE_SUFFIX } from 'core/actions/apis';

const extraRewardsDealsRootActionPath = 'core/ExtraRewardsDeals';

export const EXTRA_REWARDS_DEALS_GET_SUCCESS = `${extraRewardsDealsRootActionPath}/GET_${SUCCESS_SUFFIX}`;
export const EXTRA_REWARDS_DEALS_GET_FAILURE = `${extraRewardsDealsRootActionPath}/GET_${FAILURE_SUFFIX}`;
export const EXTRA_REWARDS_DEALS_VIEW = `${extraRewardsDealsRootActionPath}/VIEW`;
